import { Amplify } from 'aws-amplify';

Amplify.configure({
    Auth: {
        Cognito: {
            identityPoolId: 'us-east-1:146bdc74-10fd-47fe-8cbe-2e6d68c247bb',
            allowGuestAccess: true
        }
    }
});
